import { FC } from 'react';
import { Image, Text } from '@chakra-ui/react';

import clockImg from 'assets/brand/clock@2x.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import { formatDate } from 'helpers/date';

import locales from './locales';

interface DeactivationDateInfoProps {
  chosenDate?: Date | null;
  deactivateAt: string | null;
  onActionClicked: () => void;
}

const DeactivationDateInfo: FC<DeactivationDateInfoProps> = ({
  chosenDate,
  onActionClicked,
}) => (
  <>
    <Image
      alt=""
      boxSize="90px"
      marginBottom="space-16"
      role="presentation"
      src={clockImg}
    />

    <Heading marginBottom="space-16">{locales.title}</Heading>
    <Text marginBottom="space-32">{locales.description}</Text>

    <SunshineCard onClick={onActionClicked}>
      <SunshineCard.Slot name="action">
        <SunshineCard.SunshineIcon name="chevron-right" />
      </SunshineCard.Slot>

      <SunshineCard.Content>
        <SunshineCard.Title>
          {chosenDate ? locales.editDateTitle : locales.addDateTitle}
        </SunshineCard.Title>

        {chosenDate ? (
          <SunshineCard.Text>
            {locales.formatString(
              locales.actionCardDescription,
              formatDate(new Date(chosenDate), 'PP'),
            )}
          </SunshineCard.Text>
        ) : null}

        {chosenDate ? (
          <Button variant="inline-primary">{locales.actionCardCta}</Button>
        ) : null}
      </SunshineCard.Content>
    </SunshineCard>
  </>
);

export default DeactivationDateInfo;
